import { render, staticRenderFns } from "./cooperateIntroduce.vue?vue&type=template&id=dbd8524a&scoped=true"
import script from "./cooperateIntroduce.vue?vue&type=script&lang=js"
export * from "./cooperateIntroduce.vue?vue&type=script&lang=js"
import style0 from "./cooperateIntroduce.vue?vue&type=style&index=0&id=dbd8524a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd8524a",
  null
  
)

export default component.exports